import React from "react";
import { G, TYPE, FONT_FAMILY } from "../../constants/theme";

// Lightweight helper text shown below a title/metric/chart to explain what it
// means and why it matters. Intentionally subtle — smaller and lighter than
// the heading it sits under, never intended to change layout/spacing.
export default function Description({ children, light = false, style = {} }) {
  return (
    <p
      style={{
        fontFamily: FONT_FAMILY,
        ...TYPE.caption,
        color: light ? "rgba(255,255,255,0.4)" : G.gray500,
        margin: 0,
        ...style,
      }}
    >
      {children}
    </p>
  );
}
